import { Token } from './Token';
import Config from '../../config/app.config';
import { ServiceNowAdapterEvent } from '../enums';
export interface AuthorizeOptions {
    snOrigin?: string;
    clientId?: string;
    code?: string;
    clientSecret?: string;
}

export class Authorize {
    private _refreshPromise: Promise<any> | null = null;
    private snOrigin: string;
    private clientId: string;
    private code: string;
    private clientSecret?: string;
    constructor({ snOrigin, clientId, code, clientSecret }: AuthorizeOptions) {
        this.snOrigin = snOrigin || localStorage.getItem('snOrigin')!;
        this.clientId = clientId || localStorage.getItem('snClientId')!;
        this.code = code || '';
        this.clientSecret = clientSecret || localStorage.getItem('snClientSecret')!;
    }
    public _tokenRequest(params: any) {
        const snOriginUrl = new URL(this.snOrigin);
        const hostname = snOriginUrl.hostname;
        const endIdx = hostname.indexOf('.service-now.com');
        const subdomain = hostname.slice(0, endIdx);
        const url = `/crm/oauth/servicenow/oauth_token.do?site=${subdomain}`;

        if (!params.refresh_token) {
            params.redirect_uri = Config.adapterUrl;
        }
        const _postData = {
            client_id: this.clientId,
            code: this.code,
            client_secret: this.clientSecret,
            grant_type: 'authorization_code',
            ...params,
        };
        const Authorization = `Bearer ${localStorage.getItem('engage-auth:accessToken') || ''}`;
        const formData = new URLSearchParams();
        for (const key in _postData) {
            formData.append(key, _postData[key]);
        }
        return new Promise(function (resolve, reject) {
            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: Authorization,
                },
                body: formData,
            })
                .then((response) => {
                    response
                        .json()
                        .then((data) => {
                            if (data && data.access_token && data.refresh_token) {
                                resolve(data);
                            }
                            reject(data);
                        })
                        .catch(() => {
                            reject(response);
                        });
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
    public refresh() {
        if (this._refreshPromise) {
            return this._refreshPromise;
        }
        const refreshSN = () => {
            return new Promise((resolve, reject) => {
                const rfToken = () => {
                    const token = new Token();
                    if (!token.refreshToken()) {
                        token.setData(null);
                        window.rcServiceNowAdapter?.emit(ServiceNowAdapterEvent.UPDATE_IS_ERROR, true);
                        resolve(false);
                    }
                    this._tokenRequest({
                        grant_type: 'refresh_token',
                        refresh_token: token.refreshToken(),
                    })
                        .then((response: any) => {
                            this._refreshPromise = null;
                            token.setData(response);
                            resolve(true);
                        })
                        .catch((e) => {
                            if (e.status === 401) {
                                this.refreshRCXToken().then((success) => {
                                    if (success) {
                                        rfToken();
                                    } else {
                                        this._refreshPromise = null;
                                        token.setData(null); // Provide an argument here
                                        window.rcServiceNowAdapter?.signOutAgent();
                                        resolve(false);
                                    }
                                });
                            } else {
                                this._refreshPromise = null;
                                token.setData(null); // Provide an argument here
                                window.rcServiceNowAdapter?.emit(ServiceNowAdapterEvent.UPDATE_IS_ERROR, true);
                                resolve(false);
                            }
                        });
                };
                rfToken();
            });
        };
        this._refreshPromise = refreshSN();
        return this._refreshPromise;
    }
    private refreshRCXToken() {
        return new Promise(function (resolve, reject) {
            const url = `${Config.authUrl}/api/auth/token/refresh`;
            const Authorization = `${localStorage.getItem('engage-auth:tokenType') || 'Bearer'} ${localStorage.getItem(
                'engage-auth:accessToken'
            )}`;
            const _postData = { refresh_token: localStorage.getItem('engage-auth:refreshToken') || '' };
            const formData = new URLSearchParams();
            for (const key in _postData) {
                formData.append(key, _postData[key as keyof typeof _postData]);
            }
            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                    Authorization: Authorization,
                },
                body: formData,
            }).then((response) => {
                response
                    .json()
                    .then((data) => {
                        if (data && data.accessToken && data.refreshToken) {
                            localStorage.setItem('engage-auth:accessToken', data.accessToken);
                            localStorage.setItem('engage-auth:refreshToken', data.refreshToken);
                            localStorage.setItem('engage-auth:tokenType', data.tokenType);
                            resolve(true);
                        }
                        resolve(false);
                    })
                    .catch(() => {
                        resolve(false);
                    });
            });
        });
    }
}
